module.exports = __webpack_public_path__ + "img/Gifting-Dates-Icon.eae409b9.png";